"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyValuationDetailDto = instanceOfPropertyValuationDetailDto;
exports.PropertyValuationDetailDtoFromJSON = PropertyValuationDetailDtoFromJSON;
exports.PropertyValuationDetailDtoFromJSONTyped = PropertyValuationDetailDtoFromJSONTyped;
exports.PropertyValuationDetailDtoToJSON = PropertyValuationDetailDtoToJSON;
exports.PropertyValuationDetailDtoToJSONTyped = PropertyValuationDetailDtoToJSONTyped;
var PropertyValuationMediaDto_1 = require("./PropertyValuationMediaDto");
/**
 * Check if a given object implements the PropertyValuationDetailDto interface.
 */
function instanceOfPropertyValuationDetailDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('media' in value) || value['media'] === undefined)
        return false;
    return true;
}
function PropertyValuationDetailDtoFromJSON(json) {
    return PropertyValuationDetailDtoFromJSONTyped(json, false);
}
function PropertyValuationDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'propertyName': json['propertyName'] == null ? undefined : json['propertyName'],
        'propertyAddress': json['propertyAddress'] == null ? undefined : json['propertyAddress'],
        'description': json['description'] == null ? undefined : json['description'],
        'renovated': json['renovated'] == null ? undefined : json['renovated'],
        'isInterestedInListing': json['isInterestedInListing'] == null ? undefined : json['isInterestedInListing'],
        'avmResponse': json['avmResponse'] == null ? undefined : json['avmResponse'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'media': (json['media'].map(PropertyValuationMediaDto_1.PropertyValuationMediaDtoFromJSON)),
        'lastSoldDate': json['lastSoldDate'] == null ? undefined : json['lastSoldDate'],
        'lastSoldPrice': json['lastSoldPrice'] == null ? undefined : json['lastSoldPrice'],
    };
}
function PropertyValuationDetailDtoToJSON(json) {
    return PropertyValuationDetailDtoToJSONTyped(json, false);
}
function PropertyValuationDetailDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'propertyName': value['propertyName'],
        'propertyAddress': value['propertyAddress'],
        'description': value['description'],
        'renovated': value['renovated'],
        'isInterestedInListing': value['isInterestedInListing'],
        'avmResponse': value['avmResponse'],
        'name': value['name'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'countryCode': value['countryCode'],
        'media': (value['media'].map(PropertyValuationMediaDto_1.PropertyValuationMediaDtoToJSON)),
        'lastSoldDate': value['lastSoldDate'],
        'lastSoldPrice': value['lastSoldPrice'],
    };
}
